
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPrintScreenIec as ObiPrintScreenIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-print-screen-iec.js';
 
 
 

 
 export const ObiPrintScreenIec = createComponent({
   react: React,
   tagName: 'obi-print-screen-iec',
   elementClass: ObiPrintScreenIecElement,
   events: {
     
   }
  });
 
 